import appConfig from '@/features/app/constants/app-config';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { PushDeviceType } from '@/features/push/types/push-device-type';

interface StoredPushDeviceRegistration {
  id: number;
  fcmToken: string;
  deviceType: PushDeviceType;
}

interface PushDeviceRegistrationState {
  registration: StoredPushDeviceRegistration | null;
  setRegistration: (registration: StoredPushDeviceRegistration) => void;
  clearRegistration: () => void;
}

const usePushDeviceRegistrationStore = create<PushDeviceRegistrationState>()(
  persist(
    (set) => ({
      registration: null,
      setRegistration: (registration) => set({ registration }),
      clearRegistration: () => set({ registration: null }),
    }),
    {
      name: appConfig.pushDeviceStorageKey,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ registration: state.registration }),
    }
  )
);

export default usePushDeviceRegistrationStore;
